import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import LocationInfo from '../views/Location/LocationInfo.vue';
import Physicians from '../views/Physicians/physicians.vue';
import VisitType from '../views/VeinsCkeckin/VisitType.vue';
import Questionnaire from '../views/VeinsCkeckin/Questionnaire.vue';
import Demo from '../views/VeinsCkeckin/Demo.vue';

import smsTemplates from '../views/EmailSms/smsTemplates.vue';
import emailTemplates from '../views/EmailSms/emailTemplates.vue';

import StatisticReport from '../views/Reports/StatisticReport.vue'
import StaffReport from '../views/Reports/StaffReport.vue'
import DailyReport from '../views/Reports/DailyReport.vue'
import PaymentReport from '../views/Reports/PaymentReport.vue'
import PhysicianReport from '../views/Reports/PhysicianReport.vue'
import StepReport from '../views/Reports/StepReport.vue'
import VisitReport from '../views/Reports/VisitReport.vue'
import WaitTimeReport from '../views/Reports/WaitTimeReport.vue'
import AdvanceWaitTimeReport from '../views/Reports/AdvanceWaitTimeReport.vue'
import CheckoutReport from '../views/Reports/CheckoutReport.vue'

import StageAndStep from '../views/VeinsTracker/StageAndStep.vue';
import Resource from '../views/VeinsTracker/Resource.vue';
import CheckIn from '../views/CheckIn.vue';
import StageDisplay from '../views/VeinsTracker/StageDisplay.vue';
import LobbyDisplay from '../views/VeinsTracker/LobbyDisplay.vue';
import PatientPortal from '../views/Patients/PatientPortal.vue';
import AuditLog from '../views/AuditLog/AuditLog.vue';
import PaymentRequest from '../Payments/PaymentRequest.vue';
import PaymentsPaid from '../Payments/PaymentsPaid.vue';
import ProfilePage from '../views/Profile/ProfilePage';
import Checkout from "../views/VeinsTracker/Checkout.vue";
import lockscreen from '../views/lockscreen.vue';
import Upload from "../views/Upload/UploadPatients.vue";
import Tasks from "../views/Tasks/Tasks.vue";
import AuditLogTimeLine from "../views/AuditLog/AuditLogTimeLine.vue"
//import StageDisplay1 from '../views/VeinsTracker/StageDisplay22.vue';
import TaskDetail from "../views/Reports/TaskDetail.vue";
import TaskSummary from "../views/Reports/TaskSummary.vue";
import PatientTask from "../views/Tasks/PatientTask.vue"


const routes = [
  // {
  //   path: '/StageDisplay1',
  //   name: 'StageDisplay1',
  //   component: StageDisplay1
  // },

  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lockscreen',
    name: 'lockscreen',
    component: lockscreen
  },
  {
    path: '/LocationInfo',
    name: 'LocationInfo',
    component: LocationInfo
  },
  {
    path: '/Physicians',
    name: 'physicians',
    component: Physicians
  },
  {
    path: '/VisitType',
    name: 'visitType',
    component: VisitType
  },
  {
    path: '/Demo',
    name: 'Demo',
    component: Demo,
  },
  {
    path: '/Questionnaire',
    name: 'Questionnaire',
    component: Questionnaire
  },
  { 
    path: '/Questionnaire/:id/demo',
    name: 'products.demo', 
    component: Questionnaire },
  {
    path: '/smsTemplates',
    name: 'smsTemplates',
    component: smsTemplates
  },
  {
    path: '/emailTemplates',
    name: 'emailTemplates',
    component: emailTemplates
  },
  {
    path: '/StageAndStep',
    name: 'StageAndStep',
    component: StageAndStep,
  },
  {
    path: '/Resource',
    name: 'Resource',
    component: Resource
  },
  {
    path: '/CheckIn',
    name: 'CheckIn',
    component: CheckIn
  },
  {
    path: '/StageDisplay',
    name: 'StageDisplay',
    component: StageDisplay
  },
  {
    path: '/PatientPortal',
    name: 'PatientPortal',
    component: PatientPortal
  },
  {
    path: '/ProfilePage',
    name: 'ProfilePage',
    component: ProfilePage
  },
  {
    path: '/LobbyDisplay',
    name: 'LobbyDisplay',
    component: LobbyDisplay
  },
  {
    path: '/AuditLog',
    name: 'AuditLog',
    component: AuditLog
  },
  {
    path: "/Checkout",
    name: 'Checkout',
    component: Checkout
  },
  {
    path: "/CheckoutReport",
    name: 'CheckoutReport',
    component: CheckoutReport
  },
  {
    path: '/DailyReport',
    name: 'DailyReport',
    component: DailyReport
  },
  {
    path: '/PhysicianReport',
    name: 'PhysicianReport',
    component: PhysicianReport
  },
  {
    path: '/StepReport',
    name: 'StepReport',
    component: StepReport
  },
  {
    path: '/StaffReport',
    name: 'StaffReport',
    component: StaffReport
  },
  {
    path: '/PaymentReport',
    name: 'PaymentReport',
    component: PaymentReport
  },
  {
    path: '/StatisticReport',
    name: 'StatisticReport',
    component: StatisticReport
  },
  {
    path: '/StaffReport',
    name: 'StaffReport',
    component: StaffReport
  },
  {
    path: '/VisitReport',
    name: 'VisitReport',
    component: VisitReport
  },
  {
    path: '/WaitTimeReport',
    name: 'WaitTimeReport',
    component: WaitTimeReport
  },
  {
    path: '/AdvanceWaitTimeReport',
    name: 'AdvanceWaitTimeReport',
    component: AdvanceWaitTimeReport
  },
  {
    path: '/PaymentRequest',
    name: 'PaymentRequest',
    component: PaymentRequest
  },
  {
    path: '/PaymentsPaid',
    name: 'PaymentsPaid',
    component: PaymentsPaid
  },
  {
    path: '/Upload',
    name: 'Upload',
    component: Upload
  },
  {
    path: '/Tasks',
    name: 'Tasks',
    component: Tasks
  },
  {
    path:'/AuditLogTimeLine',
    name: "AuditLogTimeLine",
    component:AuditLogTimeLine
  },
  {
    path:'/TaskDetail',
    name: "TasDetail",
    component:TaskDetail
  },
  {
    path:'/TaskSummary',
    name: "TaskSummary",
    component:TaskSummary
  },
  {
    path:'/PatientTask',
    name: "PatientTask",
    component:PatientTask
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/pageWraper.vue')
  }
];



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  // str += "a1" + res.data.CanPatients + ":";
  // str += "b1" + res.data.CanUsers + ":";
  // str += "c1" + res.data.CanPractices + ":";
  // str += "d1" + res.data.CanVeinsCheckIn + ":";
  // str += "e1" + res.data.CanVisitTracker + ":";
  // str += "f1" + res.data.CanPayments + ":";
  // str += "g1" + res.data.CanEmail + ":";
  // str += "h1" + res.data.CanSms + ":";
  // str += ":";
  //debugger;// eslint-disable-line no-debugger
  //if(localStorage.cando==="") return;
  // if(to.href.includes("force01.68")) {
  //   next({ path: "/StageDisplay110011xx-xx-101-01.68" });
  //   return;
  // }
  try {
    // if(to.fullPath == "/StageDisplay110011xx-xx-101-01.68") {
    //   next({ path: "/StageDisplay" });
    // return;
    // }
   //debugger
    const where = to.name;
    if((where==="paymentreceipt") )
    {
      next();
      
    }
    else{
    const x = localStorage.cando;
    if(x === undefined)
    {
      return;
    }
    switch (where) {
      case "PatientPortal":
        if (x.includes(":a11:")) next();
        else next({ path: from.path });
        break;
      case "physicians":
      case "LocationInfo":
      case "StatisticReport":
      case "WaitTimeReport":
      case "AdvanceWaitTimeReport":
      case "DailyReport":
      case "StepReport":
      case "PhysicianReport":
      case "StaffReport":
      case "PaymentReport":
      case "ProfilePage":
      case "CheckoutReport":
        if (x.includes(":b11:")) next();
        else next({ path: from.path });
        break;
      case "CheckIn":
      case "visitType":
      case "Demo":
      case "Questionnaire":
        if (x.includes(":d11:")) next();
        else next({ path: from.path });
        break;
      case "Checkout":
      case "StageDisplay":
      case "LobbyDisplay":
      case "StageAndStep":
      case "Resource":
        if (x.includes(":e11:")) next();
        else next({ path: from.path });
        break;
      case "PaymentRequest":
      case "PaymentsPaid":
        if (x.includes(":f11:")) next();
        else next({ path: from.path });
        break;
      case "emailTemplates":
        if (x.includes(":g11:")) next();
        else next({ path: from.path });
        break;
      case "smsTemplates":
        if (x.includes(":h11:")) next();
        else next({ path: from.path });
        break;
        default:
        next();
    }
  }
  } catch { next({ path: "/" }) }
  
})


// const router = new VueRouter({
//   routes: Routes,
//   mode: 'hash'
// });

// router.beforeEach((to, from, next) => {
//  //debugger // eslint-disable-line no-debugger
//     if (to.query.area !== "1") window.location.href='https://dev-user.veinspracticesolution.com/';
//      else {
//     switch (to.path) {
//       case '/LocationInfo':
//       case '/Physicians':
//       case '/VisitType':
//       case '/Demo':
//       case '/Questionnaire':
//       case '/emailTemplates':
//       case '/smsTemplates':
//       case '/StageAndStep':
//       case '/Resource':
//       case '/CheckIn':
//       case '/StageDisplay':
//       case '/PatientPortal':
//       case '/LobbyDisplay':
//       case '/AuditLog':
//       case '/Checkout':
//       case '/CheckoutReport':
//       case '/DailyReport':     
//       case '/PhysicianReport':
//       case '/StepReport':
//       case '/PaymentReport':
//       case '/StatisticReport':
//       case '/StaffReport':
//       case '/WaitTimeReport':
//       case '/AdvanceWaitTimeReport':
//       case '/PaymentRequest':
//       case '/PaymentsPaid':
//       case '/Upload':
//       case '/About':
//         break;
//         case '':
//         break;
//       default:
//        next();
//        break;
//     }
//   }
// });

export default router
